import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { getUserAgent, getUserScreenSize } from "@/helpers/utils.js";

const getAuthHeader = () => {
  return { 
    'Authorization': 'Bearer ' +  localStorage.getItem('jwt')
    }
}

const ApiService = {
    init() {
      Vue.use(VueAxios, axios);
      Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    },
  
    list(resource) {
        return Vue.axios.get(`${resource}/list`).catch(error => {
            throw new Error(`[JN] ApiService ${error}`);
        });
    },

    query(resource, params) {
      return Vue.axios.get(resource, params).catch(error => {
        throw new Error(`[JN] ApiService ${error}`);
      });
    },

    get(resource, id = "") {
      return Vue.axios.get(`${resource}/${id}`).catch(error => {
        throw new Error(`[JN] ApiService ${error}`);
      });
    },
  
    post(resource, params) {
      return Vue.axios.post(`${resource}/add`, params, {headers: getAuthHeader()}).catch(error => {
        throw new Error(`[JN] ApiService ${error}`);
      });
    },

    update(resource, id, params) {
      return Vue.axios.put(`${resource}/update/${id}`, params, {headers: getAuthHeader()}).catch(error => {
        throw new Error(`[JN] ApiService ${error}`);
      });
    },
  
    delete(resource, id) {
      return Vue.axios.delete(`${resource}/delete/${id}`, {headers: getAuthHeader()}).catch(error => {
        throw new Error(`[JN] ApiService ${error}`);
      });
    },
  };

export default ApiService;

export const SettingsService = {
    get() {
      return Vue.axios.get(`settings`, {headers: getAuthHeader()}).catch(error => {
        throw new Error(`[JN] ApiService ${error}`);
      });
    },
    update(id, settings) {
      return ApiService.update("settings", id, settings);
    }
}
export const ProjectsService = {
    getAll() {
        return ApiService.list("projects");
    },
    get(id) {
        return ApiService.get("projects", id);
    },
    addProject(project) {
        return ApiService.post("projects", project);        
    },
    deleteProject(id) {
        return ApiService.delete("projects", id);
    },
    updateProject(id, project) {
        return ApiService.update("projects", id, project);
    }
};

export const UserService = {
    login(email, password) {
        return Vue.axios.post(`user/login`, {email, password}).catch(error => {
            throw new Error(`[JN] ApiService ${error}`);
        });
    },
    logOut() {
        if (localStorage.getItem('jwt') && localStorage.getItem('user')) {
            localStorage.removeItem('jwt');
            localStorage.removeItem('user');
        }    
    },
    isLoggedIn() {
        if (localStorage.getItem('jwt') && localStorage.getItem('user')) {
            return true;
        } else {
            return false;
        }
    }
}

export const LoggingService = {
    log(component, msg, err) {
      const clientLog = {component, msg, err, timeStamp: "", userAgent: getUserAgent(), screen: getUserScreenSize()};
      return Vue.axios.post(`logs/`, clientLog).catch(error => {
        window.console.error(error);
    });  
  },
}